module.exports = __webpack_public_path__ + "static/media/nathan.c81a7b11.png";